import styles from './styles/Input.search.module.scss';
import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
export const InputSearch = ({ name, value, setValue }) => {
    return (React.createElement("div", { className: `pos:r ${styles.wrapper}` },
        React.createElement("input", { type: "search", className: `d:block w:100 ${styles.input}`, placeholder: "Search", value: value, "aria-label": `Search ${name}`, onInput: event => { setValue(event.currentTarget.value); } }),
        React.createElement(Ssvg, { icon: "#icon__header_search", className: `pos:a ${styles.icon}` })));
};
